// app/(todos)/todos/error.tsx
'use client';

import { useEffect } from 'react';
import { Button } from '../../components/ui/button';
// import { Button } from '@/components/ui/button';

export default function TodosError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // сюда можно подключить логгер (Sentry и т.п.)
    console.error('Todos route error:', error);
  }, [error]);

  return (
    <div className="mx-auto max-w-2xl rounded-xl bg-slate-800/50 p-6 text-white shadow-2xl">
      <h2 className="text-2xl font-bold text-main">Упс, что-то пошло не так</h2>
      <p className="mt-2 text-slate-300">
        Не удалось загрузить ваши задачи. Попробуйте ещё раз.
      </p>

      <div className="mt-4 flex flex-wrap gap-2">
        <Button onClick={reset} className="bg-sky-600 hover:bg-sky-500 text-white">
          Повторить
        </Button>
        <Button
          variant="outline"
          className="border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
          onClick={() => (window.location.href = '/')}
        >
          На главную
        </Button>
      </div>

      <p className="mt-4 text-xs text-slate-500 break-all">
        {error.message}
      </p>
    </div>
  );
}
